import { useTranslation, Trans } from 'react-i18next'
import './benefits.scss'

const Benefits: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section className="benefits">
            <h2 className="benefits__header">{t('benefits.title')}</h2>
            <div className="benefits__all">
                {[...Array(6)].map((_, i) => (
                    <div className="benefit" key={i}>
                        <h3>
                            <Trans i18nKey={`benefits.items.${i}.title`} components={{ 1: <span /> }} />
                        </h3>
                        <p>{t(`benefits.items.${i}.description`)}</p>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Benefits
